'use strict';
import isFunction from 'lodash/isFunction';
import {stateGo} from 'redux-ui-router';
import {stateGoBack} from '../../app/actions';
import {formsStates} from '../router';

module.exports = [
  '$rootScope',
  '$scope',
  '$ngRedux',
  '$miscUtils',
  '$contextMenu',
  '$toast',
  '$ionicViewSwitcher',
  'FORM_SAVE_RESULT',
  'form',
  FormCreateController];

function FormCreateController(
  $rootScope,
  $scope,
  $ngRedux,
  $miscUtils,
  $contextMenu,
  $toast,
  $ionicViewSwitcher,
  FORM_SAVE_RESULT,
  form,
) {
  const vm = $scope.formCreate = this;
  vm.builderApi = {};

  /* Header Actions */
  vm.openContext = showMenu;
  vm.goBack = goBack;
  vm.save = $miscUtils.blockPromise(save, exitEditMode);

  updateHeader();
  $miscUtils.bindToExit($scope, isDirty);

  const cancelWatchApi = $scope.$watch(
    () => vm.builderApi && isFunction(vm.builderApi.setForm),
    apiReady => {
      if (apiReady) {
        cancelWatchApi();
        if (form)
          vm.builderApi.setForm(form);
        else
          vm.builderApi.createForm();
      }
    });

  function save() {
    return vm.builderApi.save().then(function (result) {
      switch (result) {
        case FORM_SAVE_RESULT.SAVED:
          return $toast.showMessage('Form Saved!', null, $toast.TOAST_TYPES.success);// TODO(i18n): convert to message code
        case FORM_SAVE_RESULT.NO_CHANGES:
          return $toast.showMessage('No Changes', null, $toast.TOAST_TYPES.info);// TODO(i18n): convert to message code
        case FORM_SAVE_RESULT.VALIDATION_FAILED:
          return $toast.showMessage('Validation Errors. Failed to save!', null, $toast.TOAST_TYPES.error);// TODO(i18n): convert to message code
        case FORM_SAVE_RESULT.ERROR_SAVING:
          return $toast.showMessage('Failed to save the form!', null, $toast.TOAST_TYPES.error);// TODO(i18n): convert to message code
      }
    })
      .catch(e => {
        $toast.showMessage('Failed to save the form!', null, $toast.TOAST_TYPES.error);// TODO(i18n): convert to message code
        return Promise.reject(e);
      });
  }

  function cancel() {
    vm.builderApi.cancel();
  }

  function create() {
    vm.builderApi.createForm();
    updateHeader();
  }

  function goBack() {
    $ngRedux.dispatch(stateGoBack({state: formsStates.forms}));

    // TODO(forms): this may need to be applied every time we enter and set a form
    const off = $rootScope.$on('$stateChangeSuccess', function () {
      // Only set the form to null if we successfully transition
      vm.builderApi.setForm(null);
      off();
    });
  }

  function showMenu() {
    const actions = [
      {messageId: 'forms.context.new.label', action: create},
    ];

    const model = vm.builderApi.getForm();
    if (model && model.$isPersisted())
      actions.push({messageId: 'forms.context.reset.label', action: cancel});

    return $contextMenu.show({
      titleMessageId: 'default.options.context.title.label',
      titleMessageParams: {name: 'Form'},
      cancelMessageId: 'defaults.context.cancel.label',
      actions: actions,
    });
  }

  function updateHeader() {
    vm.isExistingForm = isExistingForm();
    // TODO: create separate routes with each title in the config for these headers and the params to resolve
    vm.headerLabel = isExistingForm() ? 'forms.views.update.header.label' : 'forms.views.create.header.label';
  }

  function isExistingForm() {
    if (vm.builderApi.getForm) {
      const model = vm.builderApi.getForm();
      return model && model.$isPersisted();
    } else {
      return !!form;
    }
  }

  function isDirty() {
    if (vm.builderApi.isDirty) {
      return vm.builderApi.isDirty() && !vm.builderApi.isEmptyModel();
    } else {
      return false;
    }
  }

  function exitEditMode() {
    if (isDirty())
      vm.builderApi.cancel();
  }
}



// WEBPACK FOOTER //
// ./src/js/forms/controllers/FormCreateController.js